import { twMerge } from "tailwind-merge";

export default function SearchSection({
    title,
    className,
    children,
}: {
    title: string;
    className?: string;
    children?: React.ReactNode;
})
{
    return (
        <div>
            <div
                className={Wind.style({
                    paddingX: "px-3"
                }).class}
            >
                <h1
                    className={Wind.style({
                        fontSize: "text-lg",
                        fontWeight: "font-bold",
                        lineHeight: "leading-4",
                        color: "text-[#3F1413]",
                    }).class}
                >
                    {title}
                </h1>
            </div>
            <div
                className={twMerge(Wind.style({
                    paddingX: "px-3",
                    marginTop: "mt-2",
                    display: "flex",
                    flexDirection: "flex-col",
                    gap: "gap-2",
                }).class, className)}
            >
                {children}
            </div>
        </div>
    );
}
